import urlResolver from 'admin/utils/URLResolver';
import useSWR from 'swr';
import { getter } from 'core/utils/request';

export const useClassProgress = (classId) => {
  // Set url to null if the user is not a teacher.
  // This prevents useSWR from making a request (https://swr.vercel.app/docs/conditional-fetching).
  const url = urlResolver.reverse('api:class-course-progress', {
    classId,
  });

  const { data, error } = useSWR(url, getter);

  if (error) {
    console.error(error);
  }

  // transform data into a format suitable for consumption by the front end code
  // TODO this should be done on the backend
  let transformedClassProgress = data;
  if (data && !error) {
    const chunkCountTotal = data.chunk_count_total || 0;
    const chunkCountAvg = data.chunk_count_avg || 0;

    // transform lists of objects into objects keyed by object id
    // eg: [{ ...lesson}] -> { lesson_id: { ...lesson } }
    const lessons =
      data.lessons?.reduce((accumulator, lesson) => {
        accumulator[`${lesson.lesson_id}`] = lesson;
        return accumulator;
      }, {}) || {};
    const exams =
      data.exams?.reduce((accumulator, exam) => {
        accumulator[`${exam.exam_id}`] = exam;
        return accumulator;
      }, {}) || {};

    transformedClassProgress = {
      chunk_count_total: chunkCountTotal,
      chunk_count_avg: chunkCountAvg,
      lessons,
      exams,
    };
  }

  return {
    data: transformedClassProgress,
    error,
    loading: !data && !error,
  };
};
